import { render, staticRenderFns } from "./Corrugator.vue?vue&type=template&id=7130fe26&scoped=true"
import script from "./Corrugator.vue?vue&type=script&lang=js"
export * from "./Corrugator.vue?vue&type=script&lang=js"
import style0 from "./Corrugator.vue?vue&type=style&index=0&id=7130fe26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7130fe26",
  null
  
)

export default component.exports